module.exports = __webpack_public_path__ + "img/marker-oil-transport-full.4d5bc56d.png";